export default __webpack_public_path__ + "bb5a47cd9b4190495886808d66889002.svg";